import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { authApi } from '@/api/endpoints/auth';
import { ORGANIZER_LOGIN } from '@/config/routes';

export const OrganizerRoute = () => {
  const { isAuthenticated, setAuthenticated } = useAuthStore();
  const [checking, setChecking] = useState(!isAuthenticated);

  useEffect(() => {
    if (isAuthenticated) return;

    authApi
      .me()
      .then((data) => {
        setAuthenticated(data.username, data.role as 'admin' | 'organizer');
      })
      .catch(() => {
        // Cookie absent or expired – redirect handled by navigate below
      })
      .finally(() => {
        setChecking(false);
      });
  }, [isAuthenticated, setAuthenticated]);

  if (checking) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <svg
          className="h-8 w-8 animate-spin text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
          />
        </svg>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={ORGANIZER_LOGIN} replace />;
  }

  return <Outlet />;
};
